export default class extends HTMLElement {
  connectedCallback () {
    this.copy = JSON.parse(this.dataset.copy || '{}')
    this.titleEl = this.querySelector('[data-locale-title]')
    this.guidelineEl = this.querySelector('[data-locale-guideline]')
    this.continueEl = this.querySelector('button[data-locale-continue]')
    this.radiogroupEl = this.querySelector('[data-locale-radiogroup]')

    this.querySelectorAll('input[type="radio"][name="account[locale]"]').forEach((radio) => {
      radio.addEventListener('change', () => this.applyCopy(radio.value))
    })

    const checked = this.querySelector('input[type="radio"][name="account[locale]"]:checked')
    if (checked) this.applyCopy(checked.value)
  }

  applyCopy (locale) {
    const copy = this.copy[locale]
    if (!copy) return

    if (this.titleEl) this.titleEl.textContent = copy.title
    if (this.guidelineEl) this.guidelineEl.textContent = copy.guideline
    if (this.continueEl) this.continueEl.textContent = copy.continue
    if (this.radiogroupEl) this.radiogroupEl.setAttribute('aria-label', copy.language)
  }
}
